var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/utils/resize.ts";
import { convertPcToPx, convertPxToPc } from './convert';
import { correctWidths } from './correct-widths';
export function changeWidth({
  widthsPc,
  containerW,
  dragIdx,
  deltaPx,
  minWidth
}) {
  const nextWidthsPxMap = {};
  let restDeltaLeft = deltaPx;

  for (let i = dragIdx - 1; i >= 0 && restDeltaLeft !== 0; i--) {
    const itemPc = widthsPc[i] || 0;
    const itemPx = convertPcToPx(itemPc, containerW);
    let nextItemPx = itemPx + restDeltaLeft;

    if (nextItemPx - minWidth < 0) {
      nextItemPx = minWidth;
    }

    nextWidthsPxMap[i] = nextItemPx;
    const nextRestDeltaLeft = restDeltaLeft + (itemPx - nextItemPx);

    if (nextRestDeltaLeft > 0 && restDeltaLeft < 0 || nextRestDeltaLeft < 0 && restDeltaLeft > 0) {
      break;
    }

    restDeltaLeft = nextRestDeltaLeft;
  }

  let restDeltaRight = deltaPx;

  for (let i = dragIdx; i < widthsPc.length && restDeltaRight !== 0; i++) {
    const itemPc = widthsPc[i] || 0;
    const itemPx = convertPcToPx(itemPc, containerW);
    let nextItemPx = itemPx - restDeltaRight;

    if (nextItemPx - minWidth < 0) {
      nextItemPx = minWidth;
    }

    const nextRestDeltaRight = restDeltaRight - (itemPx - nextItemPx);
    nextWidthsPxMap[i] = nextItemPx;

    if (nextRestDeltaRight > 0 && restDeltaRight < 0 || nextRestDeltaRight < 0 && restDeltaRight > 0) {
      break;
    }

    restDeltaRight = nextRestDeltaRight;
  }

  const nextWidths = [...widthsPc];
  Object.entries(nextWidthsPxMap).forEach(([idx, nextWidth]) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nextWidths[idx] = convertPxToPc(nextWidth, containerW);
  });
  return correctWidths({
    widthsPc: nextWidths,
    containerW,
    foldedWidthPx: minWidth
  });
}
export function calcAllowedDelta({
  widthsPc,
  containerW,
  dragIdx,
  deltaPx,
  minWidth
}) {
  const widthsPx = widthsPc.map(w => convertPcToPx(w, containerW));
  const leftItems = widthsPx.slice(0, dragIdx);
  const rightItems = widthsPx.slice(dragIdx); // лишняя дельта слева

  const extraLeftDelta = leftItems.reduceRight((restDelta, width) => {
    if (restDelta >= 0) {
      return 0;
    }

    const allowedDelta = width - minWidth;

    if (Math.abs(restDelta) > allowedDelta) {
      return -(Math.abs(restDelta) - allowedDelta);
    }

    return 0;
  }, deltaPx); // лишняя дельта справа

  const extraRightDelta = rightItems.reduce((restDelta, width) => {
    if (restDelta <= 0) {
      return 0;
    }

    const allowedDelta = width - minWidth;

    if (Math.abs(restDelta) > allowedDelta) {
      return Math.abs(restDelta) - allowedDelta;
    }

    return 0;
  }, deltaPx);
  return deltaPx - extraLeftDelta - extraRightDelta;
}